import { useState, useMemo } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { authAPI } from '../services/api'
import { EMAIL_SPAM_NOTE } from '../config/support'
import './Page.css'

export default function ResetPassword() {
  const [searchParams] = useSearchParams()
  const tokenFromUrl = useMemo(() => searchParams.get('token')?.trim() || '', [searchParams])
  const [pwd, setPwd] = useState('')
  const [pwd2, setPwd2] = useState('')
  const [msg, setMsg] = useState(null)
  const [err, setErr] = useState(null)
  const [loading, setLoading] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setErr(null)
    setMsg(null)
    if (!tokenFromUrl) {
      setErr('This reset link is invalid or expired. Request a new one below.')
      return
    }
    if (pwd !== pwd2) {
      setErr('Passwords do not match')
      return
    }
    setLoading(true)
    try {
      const r = await authAPI.resetPassword(tokenFromUrl, pwd)
      setMsg(r?.message || 'Password updated. You can sign in now.')
      setPwd('')
      setPwd2('')
    } catch (e) {
      setErr(e.message || 'Reset failed')
    } finally {
      setLoading(false)
    }
  }

  if (!tokenFromUrl) {
    return (
      <div className="page-container">
        <div className="dashboard-card" style={{ maxWidth: 440, margin: '2rem auto' }}>
          <h1 style={{ marginTop: 0 }}>Set new password</h1>
          <p style={{ marginTop: '1rem' }}>
            This page needs the link from your reset email. If the link expired, request a new one. {EMAIL_SPAM_NOTE}
          </p>
          <p style={{ marginTop: '1rem' }}>
            <Link to="/forgot-password">Forgot password</Link>
            {' · '}
            <Link to="/">Home</Link>
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="page-container">
      <div className="dashboard-card" style={{ maxWidth: 440, margin: '2rem auto' }}>
        <h1 style={{ marginTop: 0 }}>Set new password</h1>
        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
          {msg && <p style={{ color: 'var(--success, #2d8a4e)', margin: 0 }}>{msg}</p>}
          {err && <p style={{ color: 'var(--error, #c44)', margin: 0 }}>{err}</p>}
          <div className="form-group">
            <label className="form-label" htmlFor="rp-pwd">New password</label>
            <input
              id="rp-pwd"
              type="password"
              className="form-input"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              required
              minLength={8}
              disabled={loading}
              autoComplete="new-password"
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="rp-pwd2">Confirm password</label>
            <input
              id="rp-pwd2"
              type="password"
              className="form-input"
              value={pwd2}
              onChange={(e) => setPwd2(e.target.value)}
              required
              minLength={8}
              disabled={loading}
              autoComplete="new-password"
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Saving…' : 'Update password'}
          </button>
        </form>
        <p style={{ marginTop: '1.5rem' }}>
          <Link to="/">← Back to home</Link>
        </p>
      </div>
    </div>
  )
}
